import { Injectable, signal } from '@angular/core';
import { latLngBounds, LatLng, Map } from 'leaflet';
import { MapLimits, MapStatus, isValidBounds, isValidLatLng, isValidNumber } from '../types';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { StorageService } from '../../services/storage/storage.service';

@Injectable({
	providedIn: 'root'
})
export class MapStatusService {
	mapLimits: MapLimits = {
		minZoom: 7,
		maxZoom: 18,
		maxSubBounds: latLngBounds([50.60, 9.50], [55.50, 16.00]),
		maxGlobalBounds: latLngBounds([40.30, 5.00], [65.00, 30.00])
	};

	private readonly defaultBounds = latLngBounds([53.1, 10.6], [54.7, 14.5]);
	private readonly defaultZoom = 8;

	initialized = false;
	globalMapState_ = new ReplaySubject<MapStatus>();

	panTo$ = new Subject<{ center: LatLng, zoom?: number }>();

	/** Anzahl der Layer die gerade Tiles laden (für Ladeindikator) */
	tilesLoading = signal(0);

	/** Aktueller Zoom-Level der Karte */
	currentZoom = signal(0);

	constructor(private storage: StorageService) {
		this.storage.get('MapStatus').then((status: any) => {
			const mapStatus: MapStatus = status as MapStatus;
			if (mapStatus) {
				this.globalMapState_.next(mapStatus);
			}
			else {
				this.globalMapState_.next({
					zoom: this.defaultZoom,
					center: this.defaultBounds.getCenter(),
					bounds: this.defaultBounds
				});
			}
			this.initialized = true;
		});
	}

	globalMapState(): Observable<MapStatus> {
		return this.globalMapState_;
	}

	updateMinZoomToFitMaxExtend(map: Map) {
		this.mapLimits.minZoom = map.getBoundsZoom(this.mapLimits.maxSubBounds);
	}

	saveGlobalMapState(state: MapStatus, update = true) {
		if (!this.initialized) return;
		if (state.bounds && !isValidBounds(state.bounds))
			return;
		if (state.center && !isValidLatLng(state.center))
			return;
		if (state.zoom && !isValidNumber(state.zoom))
			return;
		this.storage.setSync('MapStatus', state);
		if (update) this.globalMapState_.next(state);
	}

	panTo(center: LatLng, zoom?: number) {
		this.panTo$.next({ center, zoom });
	}
}
